import { PHONE, EMAIL, ADDRESS, WHATSAPP_LINK, INSTAGRAM_LINK, LINKEDIN_LINK, FACEBOOK_LINK } from '../constants';
import DoctoraliaWidget from './DoctoraliaWidget';

function Contact() {
    const contactLinks = [
        { label: 'WhatsApp', value: PHONE, link: WHATSAPP_LINK, icon: 'whatsapp' },
        { label: 'Instagram', value: '@psicolarafrasson', link: INSTAGRAM_LINK, icon: 'instagram' },
        { label: 'LinkedIn', value: 'Lara Frasson', link: LINKEDIN_LINK, icon: 'linkedin' },
        { label: 'Facebook', value: 'Lara Frasson', link: FACEBOOK_LINK, icon: 'facebook' },
        { label: 'E-mail', value: EMAIL, link: `mailto:${EMAIL}`, icon: 'email' },
    ];

    return (
        <section id="contato" className="py-20 bg-primary-700">
            <div className="container mx-auto px-4 max-w-6xl">
                <div className="text-center mb-16">
                    <h2 className="text-4xl font-bold text-neutral-700 mb-3">Contato & Agendamento</h2>
                    <p className="text-lg text-accent-900 opacity-80">Escolha o canal de sua preferência</p>
                </div>

                {/* Grid Superior: Agendamento Online - Mapa */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                    {/* Doctoralia Widget */}
                    <div className="bg-white/80 backdrop-blur-sm p-8 rounded-3xl shadow-lg border border-primary-200 flex flex-col min-h-[200px]">
                        <h3 className="text-2xl font-bold text-accent-700 mb-8 text-center">Agendamento Online</h3>
                        <DoctoraliaWidget />
                    </div>

                    {/* Mapa */}
                    <div className="rounded-3xl shadow-lg overflow-hidden border-4 border-white flex flex-col h-full min-h-[400px]">
                        <div className="flex-1 w-full h-full">
                            <iframe
                                src="https://www.google.com/maps?q=Rua+Albino+Silva,+455,+Bom+Retiro,+Curitiba,+PR&output=embed"
                                width="100%"
                                height="100%"
                                style={{ border: 0, minHeight: '400px' }}
                                allowFullScreen
                                loading="lazy"
                            ></iframe>
                        </div>
                    </div>
                </div>

                {/* Grid Inferior: Canais de Atendimento - Horário de Funcionamento */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* Informações de Contato */}
                    <div className="bg-white/80 backdrop-blur-sm p-8 rounded-3xl shadow-lg border border-primary-200 flex flex-col h-full">
                        <h3 className="text-2xl font-bold text-accent-700 mb-8 text-center">Canais de Atendimento</h3>
                        <div className="grid grid-cols-1 gap-3">
                            {contactLinks.map((item) => (
                                <a
                                    key={item.label}
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-4 p-4 rounded-xl hover:bg-white hover:shadow-md transition-all duration-300 group"
                                >
                                    <div className="bg-primary-900 p-3 rounded-full group-hover:scale-110 transition-transform">
                                        <img src={`/assets/icons/${item.icon}.svg`} alt={item.label} width={22} height={22} />
                                    </div>
                                    <div className="overflow-hidden">
                                        <div className="text-sm font-bold text-accent-700 uppercase tracking-wider">{item.label}</div>
                                        <div className="text-accent-900 truncate">{item.value}</div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Horário de Funcionamento */}
                    <div className="bg-white/80 backdrop-blur-sm p-8 rounded-3xl shadow-lg border border-primary-200 flex flex-col h-full">
                        <h3 className="text-2xl font-bold text-accent-700 mb-6 text-center">Horário de Funcionamento</h3>
                        <div className="flex flex-col justify-center flex-1">
                            <div className="grid grid-cols-1 gap-4">
                                <div className="flex flex-row items-center justify-between bg-primary-50 rounded-xl p-4 shadow-sm">
                                    <span className="font-medium text-neutral-700 text-lg">Segunda a Sexta</span>
                                    <span className="font-semibold text-accent-700 text-xl">08h — 20h</span>
                                </div>
                                <div className="flex flex-row items-center justify-between bg-primary-50 rounded-xl p-4 shadow-sm">
                                    <span className="font-medium text-neutral-700 text-lg">Sábado</span>
                                    <span className="font-semibold text-accent-700 text-xl">08h — 12h</span>
                                </div>
                                <div className="flex flex-row items-center justify-between bg-primary-50 rounded-xl p-4 shadow-sm">
                                    <span className="font-medium text-neutral-700 text-lg">Domingo</span>
                                    <span className="font-semibold text-red-400 text-xl">Fechado</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;